export const INITIAL_STATE = {
  File: "",
  ImageUrl: "",
  ProfileImageSaveBtn: false,
  InLineLoading: false,
  employeeBulkUploadView: false,
  OfficeId: "",
  searchEnable: false,
  personalInfo: {
    Id: 0,
    Email: "",
    FullName:"",
    DOB: "",
    Gender: "",
    MaritalStatus: "",
    PhoneNumber: "",
    Title:"",   
    NationalInsuranceNumber:"",
    PermanentAddress:"",
    ResidentialAddress:"",
    City:"",
    Country:"",
    PostalCode:"",
    StudentLoan:"",
    StudentLoanPlan:"",
    DepartmentId:""

  },
  personalInfoErrors: { 
    Email: "",
    FullName:"",
    DOB: "",
    Gender: "",
    MaritalStatus: "",
    PhoneNumber: "",
    Title:"",   
    NationalInsuranceNumber:"",
    City:"",
    Country:"",
    PostalCode:"",
    StudentLoan:"",
    StudentLoanPlan:"",
    PermanentAddress:"",
    ResidentialAddress:"",
    DepartmentId:""
  },
  personalInfoCheck: false,
  employeeDetail: {
    Level: "",
    EmployeeStatus: "",    
    HoursPerWeek: "",
    CNIC: "",
    Desigination: "",
    DepartmentId: "",
    JoiningDate: "",
    EmploymentConfirmationDate: "",
    EmployeeCode:""
  },
  employeeDetailErrors: {
    Level: "",
    EmployeeStatus: "",    
    HoursPerWeek: "",
    CNIC: "",
    Desigination: "",
    DepartmentId: "",
    JoiningDate: "", 
    EmploymentConfirmationDate: ""
  },
 employeeDetailInfoCheck:false,
  contactInfo: {
    PhoneNumber: "",
    MobileNo: "",
    EmergencyContactName: "",
    EmergencyContactNumber: ""
   },
  contactInfoErrors: {
    PhoneNumber: "",
    MobileNo: "",
    EmergencyContactName: "",
    EmergencyContactNumber: ""
  },
  contactInfoCheck: false,
  educationInfo: {
    DegreeName: "",
    Institute: "",
    MajorSubjects: "",
    CompletedYear: "",
    EmployeeId: ""
  },
  educationInfoErrors: {
    DegreeName: "",
    Institute: "",
    MajorSubjects: "",
    CompletedYear: ""
  },
  educationInfoCheck: false,
  educationArray: [],
  employee: {
    HighestQualification: "",
    JoiningDate: "",
    EmploymentConfirmationDate: "",
    Disability: "",
    PassportNo: "",
    BloodGroup: "",
    TaxNo: "",
    EOBINo: "",
    EmergencyContactAddress: "",
    DisabilityDescription: ""
  },
  familyDetail: {
    FirstName: "",
    LastName: "",
    RelationName: "",
    Gender: "",
    Age: 0,
    DOB: "",
    CNIC: "",
    EmployeeId: ""
  },
  familyDetailErrors: {
    FirstName: "",
    LastName: "",
    RelationName: "",
    Gender: "",
    Age: 0,
    DOB: "",
    CNIC: "",
    EmployeeId: ""
  },
  familyDetailCheck: false,
  familyArray: [],
  skillInfo: {
    EmployeeId: "",
    Level: "",
    SkillId: "",
    SkillName: ""
  },
  skillInfoErrors: {
    EmployeeId: "",
    Level: "",
    SkillId: "",
    SkillName: ""
  },

  skillInfoCheck: false,
  skillArray: [],
  workHistoryInfo: {
    Organisation: "",
    Role: "",
    JoiningDate: "",
    LeavingDate: "",
    Description: "",
    EmployeeId: ""
  },
  workHistoryInfoErrors: {
    Organisation: "",
    Role: "",
    JoiningDate: "",
    LeavingDate: "",
    EmployeeId: ""
  },
  otherInfo: {
    NTN: "",
    EOBI: "",
    PassportNumber: "",
    BloodGroup: "",
    DisabilityDescription: "",
    Disability: false,
    FamilyOPD: false,
    WeddingLeaves: false,
    MedicalInsurance: false,
    LeaveEncashment: false,
    EmployeeId: 0
  },
  otherInfoErrors: {
    NTN: "",
    EOBI: "",
    PassportNumber: "",
    BloodGroup: "",
    DisabilityDescription: "",
    EmployeeId: ""
  },
  workHistoryInfoCheck: false,
  workHistoryArray: [],
  employeeRecord: null,
  isError: false,
  message: "",
  title: "",
  saving: false,
  errors: {},
  addNewDepartment: false,
  departmentsList: true,
  addNewEmployeeView: false,
  employeesListView: true,
  employeeDetailView: false,
  type: "Info",
  empId: 0,
  isEditView: false,
  text: "",
  isValidForm: false,
  Loading: false,
  DefaultErrorState: {
    educationInfoErrors: {
      DegreeName: "",
      Institute: "",
      MajorSubjects: "",
      CompletedYear: ""
    },
    familyDetailErrors: {
      FirstName: "",
      LastName: "",
      RelationName: "",
      Gender: "",
      Age: 0,
      DOB: "",
      CNIC: ""
    },
    skillInfoErrors: {
      Level: "",
      SkillName: "",
      SkillId: ""
    },
    workHistoryInfoErrors: {
      Organisation: "",
      Role: "",
      JoiningDate: "",
      LeavingDate: ""
    }
  }
};
